import { formatLocalJalali } from './utc-time.js';
const root = document.querySelector('[data-notification-center]');
if (root) {
    const toggle = root.querySelector('[data-notification-toggle]');
    const list = root.querySelector('[data-notification-items]');
    const badge = root.querySelector('[data-notification-count]');
    const caption = root.querySelector('[data-notification-caption]');
    const readForm = root.querySelector('[data-notification-read-all]');
    const error = root.querySelector('[data-notification-error]');
    const number = new Intl.NumberFormat('fa-IR');
    let request, version = 0, last = '';
    function render(data) {
        badge.hidden = data.unreadCount === 0;
        badge.querySelector('bdi').textContent = data.unreadCount > 99 ? '۹۹+' : number.format(data.unreadCount);
        caption.textContent = data.unreadCount ? `${number.format(data.unreadCount)} اعلان خوانده‌نشده` : 'همهٔ اعلان‌ها را دیده‌ای';
        toggle.setAttribute('aria-label', `اعلان‌ها؛ ${number.format(data.unreadCount)} خوانده‌نشده`);
        readForm.hidden = data.unreadCount === 0;
        const signature = JSON.stringify(data.items);
        if (signature === last) return;
        last = signature;
        const focused = document.activeElement?.closest('[data-notification-id]')?.dataset.notificationId;
        list.replaceChildren(...data.items.map(item => {
            const a = document.createElement('a'); a.className = 'notification-preview' + (!item.isRead ? ' is-unread' : '');
            a.href = item.openUrl; a.dataset.notificationId = item.id;
            const icon = document.createElement('span'); icon.className = 'notification-preview-icon'; icon.setAttribute('aria-hidden', 'true');
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); svg.classList.add('ui-icon'); svg.setAttribute('viewBox','0 0 24 24');
            const use = document.createElementNS('http://www.w3.org/2000/svg', 'use'); use.setAttribute('href', '#ui-bell'); svg.append(use); icon.append(svg);
            const copy = document.createElement('span'); copy.className = 'notification-preview-copy';
            const title = document.createElement('strong'); title.textContent = item.title;
            const body = document.createElement('span'); body.textContent = item.body;
            const date = document.createElement('small'); date.textContent = formatLocalJalali(item.createdAtUtc);
            copy.append(title, body, date);
            const dot = document.createElement('span'); dot.className = 'notification-unread-dot'; dot.hidden = item.isRead; dot.setAttribute('aria-label', 'خوانده‌نشده');
            a.append(icon, copy, dot); return a;
        }));
        if (!data.items.length) {
            const empty = document.createElement('div'); empty.className = 'notification-popover-empty';
            const mark = document.createElement('span'); mark.textContent = '✓'; mark.setAttribute('aria-hidden', 'true');
            const title = document.createElement('strong'); title.textContent = 'هنوز اعلانی نداری';
            const body = document.createElement('small'); body.textContent = 'خبرهای مربوط به حسابت اینجا نمایش داده می‌شود.';
            empty.append(mark, title, body); list.append(empty);
        }
        if (focused) [...list.querySelectorAll('[data-notification-id]')].find(a => a.dataset.notificationId === focused)?.focus({ preventScroll: true });
    }
    async function refresh() {
        if (document.hidden || readForm.getAttribute('aria-busy') === 'true') return;
        const current = ++version; request?.abort(); request = new AbortController();
        try {
            const response = await fetch(root.dataset.feedUrl, { credentials: 'same-origin', cache: 'no-store', signal: request.signal, headers: { Accept: 'application/json' } });
            if (!response.ok || response.redirected) throw new Error();
            const data = await response.json(); if (current !== version) return;
            render(data); error.hidden = true;
        } catch (failure) { if (failure.name !== 'AbortError' && current === version && root.open) error.hidden = false; }
    }
    root.addEventListener('toggle', () => { toggle.setAttribute('aria-expanded', String(root.open)); if (root.open) refresh(); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && root.open) { root.open = false; toggle.focus({ preventScroll: true }); } });
    root.querySelector('[data-notification-retry]').addEventListener('click', refresh);
    readForm.addEventListener('submit', async event => {
        event.preventDefault(); ++version; request?.abort(); readForm.setAttribute('aria-busy', 'true'); readForm.querySelector('button').disabled = true;
        try {
            const response = await fetch(readForm.action, { method: 'POST', body: new FormData(readForm), credentials: 'same-origin', headers: { Accept: 'application/json' } });
            if (!response.ok || response.redirected) throw new Error(); render(await response.json()); error.hidden = true;
        } catch { error.hidden = false; }
        finally { readForm.removeAttribute('aria-busy'); readForm.querySelector('button').disabled = false; }
    });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
    window.addEventListener('pageshow', e => { if (e.persisted) refresh(); });
    window.setInterval(refresh, 45000);
}
